export default __webpack_public_path__ + "static/media/CNo.63-2.78277bbc.jpg";